import { Box, styled } from "@mui/material";

export const InformationTabe = styled("table")(({ theme }) => ({
  margin: "2em auto",
  tableLayout: "fixed",
  width: "100%",
  [theme.breakpoints.down("sm")]: {},
}));

type SMSDivProps = {
  textAlign?: string;
};

export const SMSDiv = styled(Box)<SMSDivProps>(({ theme, textAlign }) => ({
  fontSize: "20px",
  textAlign: (textAlign || "center") as "center" | "left" | "right",
  [theme.breakpoints.down("sm")]: {
    fontSize: "12px",
    textAlign: (textAlign || "left") as "center" | "left" | "right",
  },
}));

export const TitleDiv = styled(SMSDiv)(({ theme }) => ({
  fontSize: "22px",
  [theme.breakpoints.down("sm")]: {
    fontSize: "15px",
  },
}));
